import {
  ConfigObjectType,
  i18nContainer,
  loginContainer,
  StateId,
  utils,
} from '@wallaby-ui/core';
import {debounce} from 'lodash';
import * as React from 'react';
import {useMemo} from 'react';
import {defineMessages, injectIntl, WrappedComponentProps} from 'react-intl';
import {connect, ConnectedProps} from 'react-redux';
import {exportData} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import {GridPagination} from 'src/js/containers/grid/grid_slice';
import {loadStateFromParams} from 'src/js/containers/list/list_thunks';
import {useInitializeGrid} from 'src/js/hooks/useInitializeGrid';
import {RootState} from 'src/js/store';

import ListWrapperBox from './ListWrapperBox';

export const I18N = defineMessages({
  EMPTY_EXPORT: {
    id: 'export.emptyMessage',
    defaultMessage: 'It is not possible to export empty data.',
    description: 'error message on empty export',
  },
});

export interface OwnProps {
  filterAndSearchStateId: StateId;
  gridId: string;
  listStateId: StateId;
  serviceUrls: Record<string, any>;
  config: ConfigObjectType;
  caption?: string;
  exportDisabled?: boolean;
  helpText?: string;
  defaultPagination?: GridPagination;
}

const mapState = (state: RootState, props: OwnProps) => ({
  currentLocale: state[i18nContainer.I18N_REDUCER_STATE_ID].currentLocale,
  locationState: state[props.listStateId].locationState,
  isExportingCounter: state[props.filterAndSearchStateId].isExportingCounter,
});

const mapDispatch = {
  loadStateFromParamsAC: loadStateFromParams,
  exportDataAC: exportData,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & WrappedComponentProps & OwnProps;

const ListWrapperContainer: React.FC<Props> = (props) => {
  const {
    filterAndSearchStateId,
    locationState,
    gridId,
    listStateId,
    serviceUrls,
    exportDataAC,
    isExportingCounter,
    caption,
    exportDisabled,
    helpText,
    defaultPagination,
  } = props;

  const {onGridInitialize} = useInitializeGrid({
    listStateId,
    filterAndSearchStateId,
    locationState,
    gridId,
    defaultPagination,
  });

  const debouncedExportData = useMemo(
    () => debounce(exportDataAC, 500),
    [exportDataAC]
  );

  const handleExport = () => {
    const {config, currentLocale, intl} = props;
    // export data
    // TODO: replace with useMutation
    debouncedExportData(
      filterAndSearchStateId,
      serviceUrls.searchService,
      {lang: currentLocale},
      config.service.url.filesExportMethod,
      utils.TranslateUtils.translate(I18N.EMPTY_EXPORT, intl)
    );
  };

  return (
    <ListWrapperBox
      filterAndSearchStateId={filterAndSearchStateId}
      isExportingCounter={isExportingCounter}
      gridId={gridId}
      handleExport={handleExport}
      serviceUrls={serviceUrls}
      caption={caption}
      exportDisabled={exportDisabled}
      helpText={helpText}
      onGridInitialize={onGridInitialize}
    />
  );
};

ListWrapperContainer.displayName = 'ListWrapperContainer';

export default connector(injectIntl(ListWrapperContainer));
